import { render, staticRenderFns } from "./sub-category-view.vue?vue&type=template&id=1b8dc9cd&scoped=true&"
import script from "./sub-category-view.vue?vue&type=script&lang=js&"
export * from "./sub-category-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8dc9cd",
  null
  
)

export default component.exports